import { postJsonAsync } from './fetchConfig';

export const postRevalidate = entity =>  postJsonAsync(`validations`, entity);
export const postResync = entity =>  postJsonAsync(`synchronizations/resync`, entity);